module.exports =
  accepted: [false, "top", "middle", "bottom"]
  value:    false
